import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);

function processRawData( rawData ) {
  let len = rawData.length;
  let firstWeight = rawData[ 0 ].weight;
  let lastWeight = rawData[ len - 1 ].weight;

  rawData.forEach(item => {
    let temp = item.temperature + 273.0;
    let weightP = item.weight / firstWeight * 100.0;
    let conversionRate = (firstWeight - item.weight) / (firstWeight - lastWeight);

    item[ 'temperatureK' ] = temp;
    item[ 'weightP' ] = weightP;
    item[ 'conversionRate' ] = conversionRate;
    item[ 'dadt' ] = 0;
  });
}

function processDadt( rawData ) {
  let lastIdx = rawData.length - 1;
  if (lastIdx < 1) {
    window.console.log('rawData length < 2, do nothing');
    return
  }

  let currentItem, nextItem;
  for (let i = 0; i < lastIdx; ++i) {
    currentItem = rawData[ i ];
    nextItem = rawData[ i + 1 ];
    currentItem.dadt = (nextItem.conversionRate - currentItem.conversionRate) / (nextItem.time - currentItem.time);
  }

  rawData[ lastIdx ].dadt = rawData[ lastIdx - 1 ].dadt
}

const store = new Vuex.Store({
  state: {
    heatRates: [
      {
        heatRate: 1, init: false, rawData: []
      },
      {
        heatRate: 5, init: false, rawData: []
      },
      {
        heatRate: 10, init: false, rawData: []
      },
      {
        heatRate: 15, init: false, rawData: []
      },
      {
        heatRate: 20, init: false, rawData: []
      }
    ]
  },
  mutations: {
    ADD_HEAT_RATE: ( state ) => {
      state.heatRates.push({ heatRate: null, init: false, rawData: [] })
    },
    REMOVE_HEAT_RATE: ( state, heatRate ) => {
      // const heatRates = state.heatRates;
      // state.heatRates = heatRates.filter( item => item.heatRate !== heatRate);
      state.heatRates.splice(heatRate, 1);
    },
    UPDATE_HEATING_RATE_RAW_DATA: ( state, convertedData ) => {
      convertedData.body.shift();
      state.heatRates.forEach(item => {
        if (item.heatRate && item.heatRate === convertedData.heatRate) {
          let tempDatas = [];
          convertedData.body.forEach(data => {
            tempDatas.push({
              time: parseFloat(data.time),
              temperature: parseFloat(data.temperature),
              weight: parseFloat(data.weight),
              dWeight: parseFloat(data.dWeight)
            })
          });

          processRawData(tempDatas);
          processDadt(tempDatas);

          item.rawData = tempDatas;
          item.init = true;
        }
      });
    }
  },
  actions: {
    AddHeatRate( { commit } ) {
      commit('ADD_HEAT_RATE');
    },
    RemoveHeatRate( { commit }, heatRate ) {
      commit('REMOVE_HEAT_RATE', heatRate);
    },
    UpdateHeatingRateRawData( { commit }, convertedData ) {
      commit('UPDATE_HEATING_RATE_RAW_DATA', convertedData);
    }
  }
});

export default store



// WEBPACK FOOTER //
// ./src/components/store.js